// Helpers d'export CSV pour la page /stats — fonctions pures, testables en vitest nu.
//
// Convention : séparateur `;` (Excel FR ouvre direct), BOM UTF-8 en tête (préserve les
// accents quand Excel détecte l'encodage), CRLF entre lignes (compat Windows).

const BOM = '﻿';

/** Échappe une valeur pour CSV : double-quote si elle contient `;`, `"`, `\n`, `\r`. */
export function escapeCsvCell(value: unknown): string {
  if (value === null || value === undefined) return '';
  const s = typeof value === 'string' ? value : String(value);
  if (s === '') return '';
  const needsQuote = /[;"\r\n]/.test(s);
  if (!needsQuote) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

/** Construit un CSV à partir d'un header + lignes. Retourne le contenu avec BOM. */
export function buildCsv(
  headers: string[],
  rows: ReadonlyArray<ReadonlyArray<unknown>>,
): string {
  const headerLine = headers.map(escapeCsvCell).join(';');
  const dataLines = rows.map((row) => row.map(escapeCsvCell).join(';'));
  return BOM + [headerLine, ...dataLines].join('\r\n');
}
